<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    flex?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
  }>(),
  {
    flex: 1
  }
)
const tagClasses = computed(() => {
  return {
    [`myz-flex-flex-${props.flex}`]: true
  }
})
</script>

<template>
  <div :class="tagClasses"></div>
</template>
